import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "test bg-white h-40 lg:w-1/4 w-11/12 flex flex-row space-x-4 rounded-md border-t-2 border-solid border-pink-600 p-4" }
const _hoisted_2 = { class: "flex w-6 justify-center items-center text-2xl text-pink-700 flex-shrink-0" }
const _hoisted_3 = { class: "flex flex-1 justify-start items-start flex-col overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "icon")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ]))
}